import { render, staticRenderFns } from "./picupload.vue?vue&type=template&id=6287bf12&scoped=true&"
import script from "./picupload.vue?vue&type=script&lang=js&"
export * from "./picupload.vue?vue&type=script&lang=js&"
import style0 from "./picupload.vue?vue&type=style&index=0&id=6287bf12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6287bf12",
  null
  
)

export default component.exports